
import "./Card.scss";
import store, { RootState } from "../../store/store";
import { previewActions } from './previewSlice';
import { useAppSelector } from "../../hooks/redux";
import { useCallback, useEffect } from "react";
import { Card } from "../../models/Card";
import { gameActions } from "../Game/gameSlice";

export default function CardPreview() {

  const previewState = useAppSelector((state: RootState) => state.cardPreview);
  const gameState = useAppSelector((state: RootState) => state.game);

  const keyPressed = useCallback((event) => {
    switch(event.key) {
      case 'Escape':
        hide();
        break;
      case 'ArrowRight':
        showNext(+1);
        break;
      case 'ArrowLeft':
        showNext(-1);
        break;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function getNextIndex(list: Card[], card: Card, shift: number) {

    if (!list || !list.length) {
      return null;
    }

    const index = list.findIndex(it => it.cardId === card.cardId);

    if (index !== -1 && list?.length) {
      let showIndex = index + shift;

      if (showIndex >= list.length) {
        return 0;
      }

      if (showIndex < 0) {
        return list.length - 1;
      }

      return index + shift;
    }

    return null;
  }

  const showNext = (shift: number, e?: any) => {

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const preview = store.getState().cardPreview;

    if (preview.card) {
      const showIndex = getNextIndex(preview.cards, preview.card, shift);

      if (showIndex !== null) {
        store.dispatch(previewActions.hidePreview());
        store.dispatch(gameActions.sendCardArrow({ gameId: gameState.gameId, playerId: gameState.player?.data.playerId || null }));
        store.dispatch(previewActions.showPreview({ card: preview.cards[showIndex], cards: preview.cards || [] }));
      }
    }
  }

  function disableScrolling() {
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
  }

  function enableScrolling() {
    window.onscroll=function(){};
  }

  function hide(e?: any) {
    if (e) {
      e.preventDefault();
    }

    enableScrolling();
    store.dispatch(previewActions.hidePreview());
  }

  if (previewState.isPreviewVisible) {
    disableScrolling();
  }

  const previewTopOffset = window.scrollY;

  return (
    <>
      {previewState.isPreviewVisible &&
        <div onClick={(e) => hide(e)} className="game-card_preview-wrapper" style={{top: previewTopOffset}}>
          {previewState.cards?.length &&
            <div onClick={(e) => showNext(-1, e)} className="preview-arrow preview-arrow_prev"><i className="preview-arrow_prev_icon"></i></div>
          }
          <div className="game-card game-card_preview">
            <img src={previewState.card?.src} alt="card" />
          </div>
          {previewState.cards?.length &&
            <div onClick={(e) => showNext(1, e)} className="preview-arrow preview-arrow_next"><i className="preview-arrow_next_icon"></i></div>
          }
        </div>
      }
    </>
  )
}
